/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerPatchMutationRequest,
  TelegramUsersControllerPatchMutationResponse,
  TelegramUsersControllerPatch401,
} from '../types/TelegramUsersControllerPatch.ts';

function getTelegramUsersPatchUrl() {
  const res = { method: 'PATCH', url: `/api/telegram/users` as const };
  return res;
}

/**
 * {@link /api/telegram/users}
 */
export async function telegramUsersPatch(
  data?: TelegramUsersControllerPatchMutationRequest,
  config: Partial<RequestConfig<TelegramUsersControllerPatchMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramUsersControllerPatchMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerPatch401>,
    TelegramUsersControllerPatchMutationRequest
  >({ method: 'PATCH', url: getTelegramUsersPatchUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
